import { render, staticRenderFns } from "./FormLoginSecondStep.vue?vue&type=template&id=2dd80b1c"
import script from "./FormLoginSecondStep.vue?vue&type=script&lang=js"
export * from "./FormLoginSecondStep.vue?vue&type=script&lang=js"
import style0 from "./FormLoginSecondStep.vue?vue&type=style&index=0&id=2dd80b1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports